const userBgColorList = ['#ba91ff', '#68AFFF', '#EF80DB', '#FFA800', '#75D060', '#48D3D5', '#E99570', '#758395', '#9DB4E2'];
const colorLen = userBgColorList.length;

export function genAvatarBgColor(userId: string) {
    if (!userId) {
        return userBgColorList[colorLen - 1];
    }
    const key = userId.charAt(userId.length - 1);
    const chars = 'a b c d e f g h i j k l m n o p q r s t u v w x y z 0 1 2 3 4 5 6 7 8 9'.split(' ');
    const index = chars.findIndex(c => c === key) % colorLen;
    return userBgColorList[index];
}

export function trim(s: string) {
    if (s.length <= 20) return s;
    return s.substring(0, 20) + '...';
}
